import React, { useState, useEffect } from "react";
import { Modal, Button, Form, ListGroup } from "react-bootstrap"; 
import { Avatar } from "@mui/joy";
import { searchUsersAPI, grantAwardAPI } from "../reduxData/user/userAction";
import { toast } from "react-toastify";

const AwardUser = ({ show, handleClose, award, onAwardGranted }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (searchTerm.length < 2) {
      setSearchResults([]);
      return;
    }

    const delayDebounceFn = setTimeout(async () => {
      setIsLoading(true);
      const users = await searchUsersAPI(searchTerm);
      setSearchResults(users);
      setIsLoading(false);
    }, 500); 

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);
  
  const handleExited = () => {
    setSearchTerm("");
    setSearchResults([]);
    setSelectedUser(null);
  };
  
  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setSearchTerm("");
    setSearchResults([]);
  };

  const handleGrantAward = async () => {
    if (!selectedUser) {
      toast.warn("Please select a user first.");
      return;
    }
    setIsSubmitting(true);
    const success = await grantAwardAPI(selectedUser._id, award._id);
    if (success) {
      onAwardGranted(); 
    }
    setIsSubmitting(false);
  };

  return (
    <Modal show={show} onHide={handleClose} onExited={handleExited} centered>
      <Modal.Header closeButton>
        <Modal.Title>Grant Award: <span className="text-warning">{award?.text}</span></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedUser ? (
          <div className="text-center">
            <h5>Confirm User</h5>
            <Avatar src={selectedUser.profile_pic} size="lg" />
            <p className="mt-2 fw-bold">{selectedUser.user_name}</p>
            <Button variant="link" size="sm" onClick={() => setSelectedUser(null)}>
              (Change User)
            </Button>
          </div>
        ) : (
          <>
            <Form.Group>
              <Form.Label>Search for a user by name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Start typing..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Form.Group>

            {isLoading && <div className="mt-3">Searching...</div>}

            {searchResults.length > 0 && !isLoading && (
              <ListGroup className="mt-3">
                {searchResults.map((user) => (
                  <ListGroup.Item
                    action
                    key={user._id}
                    onClick={() => handleSelectUser(user)}
                    className="d-flex align-items-center"
                  >
                    <Avatar src={user.profile_pic} size="sm" className="me-3" />
                    {user.user_name}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button 
            variant="warning" 
            onClick={handleGrantAward} 
            disabled={!selectedUser || isSubmitting}
        >
          {isSubmitting ? "Granting..." : "Grant Award"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AwardUser;